import { render, staticRenderFns } from "./annualReport56_1Main.vue?vue&type=template&id=c83da538&scoped=true"
import script from "./annualReport56_1Main.vue?vue&type=script&lang=js"
export * from "./annualReport56_1Main.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c83da538",
  null
  
)

export default component.exports